import { useGlobalStore } from '@/stores/global'

export function registerPiniaPlugins(app, pinia) {
  app.use(pinia)

  // Register the store globally
  app.config.globalProperties.$globalStore = useGlobalStore(pinia)
}
